// extracted by mini-css-extract-plugin
export var dividerLine = "_7a-3";
export var itemImage = "_7a-9";
export var lightDivider = "_7a-4";
export var modalContent = "_7a-5";
export var modalContentCompact = "_7a-6";
export var productCard = "_7a-a";
export var productImage = "_7a-b";
export var productImageCompact = "_7a-7";
export var productImagePlaceholder = "_7a-c";
export var productImagePlaceholderCompact = "_7a-8";
export var progressBarBackground = "_7a-1";
export var progressBarContainer = "_7a-0";
export var progressBarFill = "_7a-2";